export const COST_CENTER_PATH = {
  GET_COST_CENTERS: "v1/organization/{0}/cost-centers/",
  CREATE_COST_CENTER: "v1/organization/{0}/cost-center/create-or-update/",
  UPDATE_COST_CENTER: "v1/organization/{0}/cost-center/create-or-update/",
  PATCH_COST_CENTER_STATUS: "v1/organization/{0}/cost-center/{1}/status/",
  DELETE_COST_CENTER: "v1/organization/{0}/cost-center/{1}/delete",
};
